import { tokenService } from './token-service';
export const requireAuth = (serverConfig) => (req, res, next) => {
    try {
        const validateToken = (req) => {
            if (req.headers.authorization) {
                const tokenData = tokenService.verify(req.headers.authorization, serverConfig);
                if (tokenData) {
                    req['user'] = tokenData;
                    return tokenData;
                }
            }
            return null;
        };
        const validMember = validateToken(req);
        if (!validMember) {
            console.log('Unauthorized jwt token');
            res.status(401).send('Unauthorized');
        }
        else {
            // console.log(`Serving verified user: ${validMember.nameid}`);
            next();
        }
    }
    catch (error) {
        console.log(error);
        res.status(401).json({
            error,
            message: 'Unauthorized',
        });
    }
};
